module.exports = __webpack_public_path__ + "static/media/0.b4b67483.jpg";